import { useNotifications } from "contexts/Toast/ToastProvider";
import React from "react";
import { SWRConfig } from "swr";

type Props = { children: React.ReactNode };
const fetcher = (input: RequestInfo, init: RequestInit | undefined) =>
  fetch(input, init).then((res) => res.json());

export function SWRConfigProvider({ children }: Props) {
  const { notify } = useNotifications();

  return (
    <SWRConfig
      value={{
        fetcher,
        onError: (error) => {
          notify(
            `Something wrong happened. ${
              error?.info?.message ||
              "An error occurred while fetching the data."
            }`,
          );
        },
      }}
    >
      {children}
    </SWRConfig>
  );
}
